import { useMonarchRule } from "../MonarchRulesProvider";
import { ExecEdBTFTestData, UseExecEdBTF } from "./types";

const CUSTOM_RULE_ID = "execEdBtfTest";

const defaultSectionsOrder = {
  promoBanner: 0,
  about: 1,
  curriculum: 2,
  certificate: 3,
  facts: 4,
  brochure: 5,
  whyGetSmarter: 6,
};

const useExecEdBTF: UseExecEdBTF = () => {
  const { isLoading, value } = useMonarchRule<{
    data: ExecEdBTFTestData;
  }>(CUSTOM_RULE_ID, {});

  if (isLoading) {
    return {
      isLoading,
      data: {
        enableTest: false,
        sectionsOrder: defaultSectionsOrder,
      },
    };
  }
  const variant = value?.data?.enableTest ? "test" : "control";

  return {
    isLoading,
    variant,
    data: {
      enableTest: value?.data?.enableTest,
      hideStickyNav: value?.data?.hideStickyNav,
      sectionsOrder: value?.data?.sectionsOrder ?? defaultSectionsOrder,
    },
  };
};

export default useExecEdBTF;
